import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ToolbarActions } from '@shared/ui/tp-toolbar/toolbar-actions';

@Component({
  selector: 'app-users',
  imports: [RouterOutlet, ToolbarActions, CommonModule, RouterLink],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
})
export class UsersComponent {}
